var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',{staticClass:"list"},[_c('tr',[_vm._l((_vm.footer),function(foot){return [(!foot.disable)?_c('td',{class:foot.supData ? 'sup_data' : '',attrs:{"colspan":foot.colspan}},[_c('strong',[_vm._v(_vm._s(foot.value)+" "+_vm._s(foot.after))])]):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }